import Img1 from "./img-1.jpg";
import Img2 from "./img-2.jpg";
import Img3 from "./img-3.jpg";
import Img4 from "./img-4.jpg";
import Img5 from "./img-5.jpg";
import Img6 from "./img-6.jpg";
import Img7 from "./img-7.jpg";
import Img8 from "./img-8.jpg";
import Img9 from "./img-9.jpg";
import Img10 from "./img-10.jpg";
import Img11 from "./img-11.jpg";
import Img12 from "./img-12.jpg";

export const photos = [
  {
    src: Img11,
    width: 4,
    height: 2.5,
  },
  {
    src: Img2,
    width: 1,
    height: 0.7,
  },
  {
    src: Img3,
    width: 4,
    height: 2.7,
  },
  {
    src: Img4,
    width: 4,
    height: 2,
  },
  {
    src: Img5,
    width: 3,
    height: 2,
  },
  {
    src: Img6,
    width: 4,
    height: 2.5,
  },
  {
    src: Img7,
    width: 1,
    height: 0.6,
  },
  {
    src: Img8,
    width: 3,
    height: 1.7,
  },
  {
    src: Img9,
    width: 4,
    height: 2.5,
  },
  {
    src: Img10,
    width: 2,
    height: 1.2,
  },
  {
    src: Img1,
    width: 4,
    height: 2.7,
  },
  {
    src: Img12,
    width: 4,
    height: 3,
  },
];
